export default "__VITE_ASSET__67e0cc96__"